// extracted by mini-css-extract-plugin
export var label = "_fx-0";
export var treatmentCard = "_fx-1";